import { SignUpBanner } from 'core/ui/components/sign-up-banner/SignUpBanner'

import { user } from 'legacy/utils/user'

import {
  isProposalAwarded,
  isProposalDeleted,
  isProposalExpired,
  isProposalFinalized,
  isProposalSubmitted,
  type Proposal,
} from '../domain/Proposal'
import { ErrorBanners } from './ErrorBanners'
import { ReviewAwardedLanesBanner } from './ReviewAwardedLanesBanner'
import { SubmitBanners } from './SubmitBanners'
import { UploadLanesFileBanners } from './UploadLanesFileBanners'

function shouldDisplayBanners(proposal?: Proposal) {
  const isNotLoggedInUser = !user.isLoggedIn()

  const isAwarded = isProposalAwarded(proposal)
  const isDeleted = isProposalDeleted(proposal)
  const isExpired = isProposalExpired(proposal)
  const isFinalized = isProposalFinalized(proposal)
  const isSubmitted = isProposalSubmitted(proposal)

  const result = {
    shouldDisplayAwardedLanesBanner: false,
    shouldDisplaySignUpBanner: false,
  }

  if (isDeleted || isFinalized || (isExpired && !isSubmitted)) {
    result.shouldDisplaySignUpBanner = isNotLoggedInUser
  } else if (isSubmitted) {
    if (isAwarded) {
      result.shouldDisplayAwardedLanesBanner = true
    } else {
      result.shouldDisplaySignUpBanner = isNotLoggedInUser
    }
  }

  return result
}

type ProposalPageBannersProps = {
  proposal: Proposal
  proposalId: string
}

export function ProposalPageBanners({ proposal, proposalId }: ProposalPageBannersProps) {
  const { shouldDisplayAwardedLanesBanner, shouldDisplaySignUpBanner } =
    shouldDisplayBanners(proposal)

  return (
    <>
      {shouldDisplayAwardedLanesBanner && <ReviewAwardedLanesBanner rfpId={proposalId} />}
      {shouldDisplaySignUpBanner && <SignUpBanner />}
      <UploadLanesFileBanners proposal={proposal} />
      <SubmitBanners proposal={proposal} />
      <ErrorBanners />
    </>
  )
}
